export const formatNumber = (number) => {
  return parseFloat(number).toLocaleString("it-IT", {
    maximumFractionDigits: 2,
  });
};
